import { Navigate, useLocation } from "react-router-dom";
import ServiceForm from "./ServiceForm";

export default function EditService() {
  const { state } = useLocation();

  // The service to edit is passed via router state from the services list.
  if (!state) {
    return <Navigate to="/admin/services" />;
  }

  return <ServiceForm mode="edit" initial={state} />;
}
